export const VARIANT_CONTRIBUTION = 'contribution';
export const VARIANT_STAY = 'stay';
export const VARIANT_OPTION = 'option';
export const VARIANT_GOOD = 'good';

export const STATUS_NEW = 0;
export const STATUS_WAITING = 1;
export const STATUS_CONTRIBUTION = 2;
export const STATUS_DEPOSIT_PAID = 3;
export const STATUS_ACK_SENT = 4;
export const STATUS_INFORMATION_SENT = 5;
export const STATUS_ORDER_PAID = 10;
export const STATUS_REFUND = 11;
export const STATUS_INVOICE = 12;
export const STATUS_PAIEMENT_ERROR = 20;
export const STATUS_PRE_ORDER = 30;
export const STATUS_CANCELED = 90;
export const STATUS_CLOSED = 91;
export const STATUS_OVER = 92;

export const ORDER_STATUSES = [
  { id: STATUS_NEW, name: 'Nouveau', color: 'bg-grey text-white' },
  { id: STATUS_WAITING, name: "En attente d'acompte", color: 'bg-blue text-white' },
  { id: STATUS_PRE_ORDER, name: 'En pré-inscription', color: 'bg-blue text-white' },
  { id: STATUS_CONTRIBUTION, name: 'A jour de cotisation', color: 'bg-green-300 text-white' },
  { id: STATUS_DEPOSIT_PAID, name: 'Acompte payé', color: 'bg-green text-white' },
  { id: STATUS_ACK_SENT, name: 'Accusé de réception envoyé', color: 'bg-orange-200 text-black' },
  {
    id: STATUS_INFORMATION_SENT,
    name: 'Information dossier envoyée',
    color: 'bg-orange text-black',
  },
  { id: STATUS_ORDER_PAID, name: 'Dossier complet', color: 'bg-green-700 text-white' },
  { id: STATUS_REFUND, name: 'Remboursé', color: 'bg-green-300 text-white' },
  { id: STATUS_INVOICE, name: 'Facture éditée', color: 'bg-grey-500 text-white' },
  { id: STATUS_PAIEMENT_ERROR, name: 'Erreur lors du paiement', color: 'bg-red-700 text-white' },
  { id: STATUS_CANCELED, name: 'Annulé', color: 'bg-grey text-white' },
  { id: STATUS_CLOSED, name: 'Clôturée', color: 'bg-grey-800 text-white' },
  { id: STATUS_OVER, name: "Annulé par l'association", color: 'bg-grey text-white' },
];

export const DETAIL_NEW_ORDER = 'new-order';
export const DETAIL_PRE_ORDER = 'pre-order';
export const DETAIL_WAITING = 'waiting';
export const DETAIL_CANCEL = 'cancel';
export const DETAIL_CANCEL_SOC = 'cancel_soc';
export const DETAIL_COMPLETE = 'complete';
export const DETAIL_CLOSED = 'closed';
export const DETAIL_VALIDATED = 'validated';

export const ATTACHMENT_STATUSES = [
  { id: '', name: '', color: '' },
  { id: DETAIL_NEW_ORDER, name: 'Nouveau', color: 'bg-orange text-white' },
  { id: 'new', name: 'Nouveau document', color: 'bg-orange text-white' },
  { id: 'read', name: 'En cour de vérification', color: 'bg-blue text-white' },
  { id: 'uncomplete', name: 'Incomplet', color: 'bg-red-700 text-white' },
  { id: DETAIL_VALIDATED, name: 'Validé', color: 'bg-green-200 text-black' },
  { id: DETAIL_COMPLETE, name: 'Complet', color: 'bg-green text-white' },
  { id: DETAIL_CANCEL, name: 'Annulé', color: 'bg-grey text-white' },
  { id: DETAIL_WAITING, name: "Liste d'attente", color: 'bg-red-300 text-black' },
  { id: DETAIL_PRE_ORDER, name: 'Pré-inscription', color: 'bg-red-300 text-black' },
  { id: DETAIL_CANCEL_SOC, name: "Annulé par l'association", color: 'bg-grey text-white' },
];

export const ORDER_DETAIL_STATUSES = [
  { id: DETAIL_NEW_ORDER, name: 'Nouveau' },
  { id: DETAIL_PRE_ORDER, name: 'Pré-inscription' },
  { id: DETAIL_WAITING, name: "Liste d'attente" },
  { id: DETAIL_CANCEL, name: "Annulé à la demande de l'adhérent" },
  { id: DETAIL_CANCEL_SOC, name: "Annulé par l'association" },
  { id: DETAIL_COMPLETE, name: 'Complété' },
  { id: DETAIL_CLOSED, name: 'Clôturé' },
  { id: DETAIL_VALIDATED, name: 'Validé' },
];
